import React, { Component, Fragment } from "react";
import { LoggedUserContext } from "../LoggedUserContext";

import {
  Button,
  TextField,
  DialogActions,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogTitle,
  Grid,
  makeStyles,
  FormControl,
  InputLabel,
  Select,
  Input,
  MenuItem,
  Checkbox,
  ListItemText,
} from "@material-ui/core/";

import { Spinner } from "./Spinner";
import axios from "axios";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { acquireToken } from "../adalConfig";

const MySwal = withReactContent(Swal);

const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: theme.spacing(0),
    minWidth: 175,
    maxWidth: 175,
  },
  chips: {
    display: "block",
    flexWrap: "wrap",
  },
  chip: {
    margin: 0,
  },
  noLabel: {
    marginTop: theme.spacing(1),
  },
}));

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 200,
    },
  },
};

export default class UserCreateForm extends Component {
  state = {
    open: false,
    loading: false,
    userEmail: "",
    user: [],
    accountList: [],
    account: [],
    rollList: [],
    roll: [],
    userRolls: [],
    userEmailAccounts: [],
    userSession: this.context,

    EmailError: "",
    AccountError: "",
    RollError: "",
  };

  async getGPN() {
    let rolles = this.state.roll;
    let listaRolles = [];
    let validUser = false;

    rolles.map((obj) =>
      this.state.rollList.map((rol) =>
        rol.rollName === obj ? listaRolles.push(rol) : null
      )
    );

    let accounts = this.state.account;
    let listAccounts = [];

    accounts.map((obj) =>
      this.state.accountList.map((rol) =>
        rol.emailAccountName === obj ? listAccounts.push(rol) : null
      )
    );

    await acquireToken().then(async (token) => {
      //let url = `${process.env.REACT_APP_API_URL}/UserAPI/GetUserNamePerEmail/${this.state.userEmail}`;
      let url = `${process.env.REACT_APP_API_URL}/UserAPI/GetUserNamePerEmail`;
      await axios
        //.get(url, { headers: { Authorization: `Bearer ${token}` } })
        .post(url, { email: this.state.userEmail }, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            this.setState({
              user: res.data.items[0],
            });
            validUser = true;
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the user",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }
        });
      if (validUser) {
        let datas = {
          userToAffect: this.state.user,
          userSession: this.state.userSession,
          userRolls: listaRolles,
          userEmailAccounts: listAccounts,
        };
        url = `${process.env.REACT_APP_API_URL}/UserAPI/AddUser`;

        await axios
          .post(url, datas, {
            headers: {
              "content-type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          })
          .then((res) => {
            if (res.data.code === 0) {
              MySwal.fire({
                icon: "success",
                title: "The user was added successfully",
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              }).then(() => {
                window.location.reload();
              });
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while adding the user",
                //text: res.data.description,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          })
          .catch((error) => {
            if (error.toString().includes("status code 403")) {
              window.location.href = "/NoAuth";
            } else {
              MySwal.fire({
                icon: "error",
                title: "An error has occurred while adding the user",
                //text: error,
                confirmButtonColor: "#FFE600",
                confirmButtonText: "<div style='color: black'>OK</div>",
              });
            }
          });
      }
    });
  }

  handleSubmit = (event) => {
    if (this.ValidateUser()) {
      event.preventDefault();
      this.getGPN();
    }
  };

  handleToggle = () => {
    this.setState({
      open: !this.state.open,
    });
  };

  handlechange = (name) => ({ target: { value } }) => {
    this.setState({
      ...this.state,
      [name]: value,
    });
  };

  async UNSAFE_componentWillMount() {
    this.setState({ loading: true });
    let itemsAccounts = [];
    let url = `${process.env.REACT_APP_API_URL}/EmailAccountAPI/GetEmailAccounts/true`;

    await acquireToken().then(async (token) => {
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            itemsAccounts = res.data.items;
          }else if(res.data.code === 2601 || 2627){
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while adding the email account",
              text: "This user already exists",
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            });
          }else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the campaigns",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      let itemsRolls = [];
      url = `${process.env.REACT_APP_API_URL}/RollAPI/GetRolls`;
      await axios
        .get(url, { headers: { Authorization: `Bearer ${token}` } })
        .then((res) => {
          if (res.data.code === 0) {
            itemsRolls = res.data.items;
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the rolls",
              //text: res.data.description,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        })
        .catch((error) => {
          if (error.toString().includes("status code 403")) {
            window.location.href = "/NoAuth";
          } else {
            MySwal.fire({
              icon: "error",
              title: "An error has occurred while retrieving the rolls",
              //text: error,
              confirmButtonColor: "#FFE600",
              confirmButtonText: "<div style='color: black'>OK</div>",
            }).then(() => {
              window.location.reload();
            });
          }
        });

      this.setState({
        accountList: itemsAccounts,
        rollList: itemsRolls,
        loading: false,
      });
    });
  }

  render() {
    const {
      open,
      userEmail,
      loading,
      accountList,
      account,
      rollList,
      roll,
    } = this.state;

    return loading ? (
      <Spinner />
    ) : (
      <Fragment>
        <Button onClick={this.handleToggle}>Add User</Button>

        <Dialog open={open} onClose={this.handleToggle} style={{ zIndex: 100 }}>
          <DialogTitle id="form-dialog-title">Add User</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Please fill out the form below
            </DialogContentText>
            <form>
              <Grid container spacing={2}>
                <Grid item>
                  <TextField
                    required
                    label="Email Address"
                    value={userEmail}
                    onChange={this.handlechange("userEmail")}
                    margin="normal"
                  />
                  <div style={{ color: "red" }}>{this.state.EmailError}</div>
                </Grid>

                <Grid item>
                  <FormControl
                    variant="outlined"
                    classitem={useStyles.formControl}
                    style={{ width: "175px" }}
                  >
                    <InputLabel shrink htmlFor={"Account"} required>
                      Email accounts
                    </InputLabel>

                    <Select
                      multiple
                      value={account}
                      primary={account.emailAccountName}
                      onChange={this.handlechange("account")}
                      input={<Input />}
                      renderValue={(selected) => selected.join(", ")}
                      MenuProps={MenuProps}
                    >
                      {accountList.map((name) => (
                        <MenuItem
                          key={name.emailAccountId}
                          value={name.emailAccountName}
                        >
                          <Checkbox
                            checked={
                              account.indexOf(name.emailAccountName) > -1
                            }
                          />
                          <ListItemText primary={name.emailAccountName} />
                        </MenuItem>
                      ))}
                    </Select>
                    <div style={{ color: "red" }}>
                      {this.state.AccountError}
                    </div>
                  </FormControl>
                </Grid>

                <Grid item>
                  <FormControl
                    variant="outlined"
                    classitem={useStyles.formControl}
                    style={{ width: "175px" }}
                  >
                    <InputLabel shrink htmlFor={"Roll"} required>
                      Roles
                    </InputLabel>

                    <Select
                      multiple
                      value={roll}
                      onChange={this.handlechange("roll")}
                      input={<Input />}
                      renderValue={(selected) => selected.join(", ")}
                      MenuProps={MenuProps}
                    >
                      {rollList.map((name) => (
                        <MenuItem key={name.rollId} value={name.rollName}>
                          <Checkbox
                            checked={roll.indexOf(name.rollName) > -1}
                          />
                          <ListItemText primary={name.rollName} />
                        </MenuItem>
                      ))}
                    </Select>
                    <div style={{ color: "red" }}>{this.state.RollError}</div>
                  </FormControl>
                </Grid>
              </Grid>
              <Button
                type="button"
                color="primary"
                style={{ marginTop: "20px" }}
                onClick={this.handleSubmit}
              >
                Add User
              </Button>
            </form>
          </DialogContent>
          <DialogActions></DialogActions>
        </Dialog>
      </Fragment>
    );
  }

  ValidateUser = () => {
    let valid = true;
    if (this.state.userEmail === "" || this.state.userEmail === undefined) {
      this.setState({ EmailError: "This field is required" });
      valid = false;
    } else if (
      // eslint-disable-next-line
      /^([a-zA-Z0-9_\-\.]+)@(([a-zA-Z0-9_\-\.]+)\.)*(ey\.)(com|net)+$/.test(
        this.state.userEmail
      ) === false
    ) {
      this.setState({ EmailError: "The email format is invalid or is not an ey account" });
      valid = false;
    } else {
      this.setState({ EmailError: "" });
    }

    if (this.state.roll.length === 0) {
      this.setState({ RollError: "This field is required" });
      valid = false;
    } else {
      this.setState({ RollError: "" });
    }

    if (this.state.account.length === 0) {
      this.setState({ AccountError: "This field is required" });
      valid = false;
    } else {
      this.setState({ AccountError: "" });
    }

    return valid;
  };
}

UserCreateForm.contextType = LoggedUserContext;
